{
    "button.copy": "复制",
    "button.email": "电子邮件",
    "button.share": "分享",
    "button.sms": "短信",
    "footer.poweredBy": "由<linkText>冰淇淋社交<\/linkText>提供支持",
    "footer.privacyPolicy": "隐私政策",
    "footer.termsAndConditions": "条款和条件",
    "offer.hint": "当{conversionGoal, plural, one {# 位朋友购买时 } two {# 个朋友购买时 } few {# 个朋友购买时 } many {# 个朋友购买时 } other {# 个朋友购买时 }} ，您将收到奖励！",
    "optInMessage": "要参与并与您的朋友分享，请让我们知道如何联系您提供优惠和奖励更新",
    "order.confirmed": "订单 # {orderId}已确认！",
    "order.details": "查看订单详情",
    "share.email.duplicateError": "哎呀！您已经添加了该电子邮件。",
    "share.email.heading": "通过电子邮件邀请朋友",
    "share.email.inputLabel": "朋友的电子邮件地址",
    "share.email.inputSubmit": "进入",
    "share.email.invitesSubmit": "发送邀请",
    "share.email.moreOptions": "更多共享选项",
    "share.email.subheading": "在下方输入您朋友的电子邮件地址",
    "share.general.help": "<bold>遇到麻烦了吗？ <\/bold>如果您的设备上未安装应用程序，则可能无法打开，请尝试通过您的个人链接使用<bold2>分享<\/bold2>",
    "share.general.linkLabel": "使用您的个人链接在任何地方分享",
    "share.general.otherOptions": "或立即在这些平台上分享",
    "thankyou.dismissCTA": "解雇",
    "thankyou.heading": "感谢分享！",
    "thankyou.message": "你是冠军！我们会将您的奖励进度更新发送到您的收件箱。",
    "thankyou.reminder": "请记住，如果您想继续分享，您以后随时可以重新访问此优惠。",
    "thankyou.shareCTA": "继续分享",
    "unlock.consentExplanation": "我们将使用您提供的信息与您取得联系。您可以随时取消订阅，但您可能会错过有关您的报价的更新",
    "unlock.consentPolicyExplanation": "我们重视您的隐私。要了解如何使用您的信息，请阅读我们的<linkText>隐私和 Cookie 政策<\/linkText>",
    "unlock.emailConsentOptIn": "给我发电子邮件更新",
    "unlock.error.invalidEmail": "请输入有效电子邮件",
    "unlock.error.noConsent": "请同意电子邮件通讯以参与此优惠",
    "unlock.input": "您的电子邮件地址",
    "unlock.label": "激活报价",
    "share.general.copySuccess": "✨链接已复制！"
}